import Context from './Context';
import { useContext } from 'react';

export const useStore = () => {
  const [state, dispatch] : any = useContext(Context);
  return [state, dispatch];
};
